import Box from '@mui/material/Box';
import { Outlet } from 'react-router';

/**
 * Placeholder para /agencies/:agencyId
 * No debe abrir ninguna vista (por ejemplo, usuarios) automáticamente.
 * Mantiene <Outlet /> para no romper rutas anidadas (diálogos) si existieran.
 */
const AgencyPlaceholder = () => {
    return (
        <Box sx={{ height: '100%', overflow: 'auto' }}>
            <Outlet />
        </Box>
    );
};

export default AgencyPlaceholder;


